import React from "react";

import DishEditor from "../_dishEditor/DishEditor";

const CreateDishComponent = ({ dishes, isDishesLoading, handleCreateDish }) => {
  const initialDish = {
    name: "",
    category: "",
    subcategory: "",
    calories: "",
    price: "",
    serving: "",
    composition: "",
    description: "",
    pictureURL: ""
  };

  return (
    <div className="subSection">
      <h3 className="subSection__heading">Create new item</h3>
      <DishEditor
        dish={initialDish}
        dishes={dishes}
        handleCreateDish={handleCreateDish}
      />
    </div>
  );
};

export default CreateDishComponent;
